import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/Layout/Header/Header";
import Footer from "../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../components/Common/ScrollTop";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import SearchModal from "../../../components/Layout/Header/SearchModal";
// Image
import footerLogo from "../../../assets/img/logo/lite-logo.png";

import QuickLinks from "../../../components/Common/QuickLinks";
import { BlocksRenderer } from "../../../components/BlockRenderer";
import { fetchData } from "../../../utils/fetchData";
import {
  getAPIPath,
  getMenu,
  getPageTitle,
} from "../../../utils/getDomainData";
const StudentActivities = () => {
  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  useEffect(() => {
    fetchData(getAPIPath()?.student_activities, setData);
    fetchData(getAPIPath()?.details_of_papers, setTableData);
  }, []);
  return (
    <React.Fragment>
      <Helmet>
        <title>Student Activities – {getPageTitle()}</title>
        <meta name="description" content="" />
        <meta name="keywords" content=""></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <div className="pageTopOffset">
        <SiteBreadcrumb
          pageTitle="Student Activities"
          pageName="Student Activities"
          breadcrumbsClass="breadcrumb-bg"
        />
        {getMenu()}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col-lg-9 md-mb-30">
                <div className="content-wrapper">
                  <div className="content-section">
                    <h3 style={{ marginBottom: "20px" }} title={data?.data?.attributes?.Page_Heading}>
                      {data?.data?.attributes?.Page_Heading}
                    </h3>
                    <h4 style={{ marginTop: "30px" }} title="EVENTS ATTENDED">EVENTS ATTENDED</h4>
                    <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">Sr. No.</th>
                          <th scope="col">
                            Name of the Department / University/ Institute
                          </th>
                          <th scope="col">Name of the Student</th>
                          <th scope="col">Number of Paper Presented</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData?.data?.map((obj, index) => (
                          <tr>
                            <td>{index + 1}.</td>
                            <td>{obj?.attributes?.Department}</td>
                            <td>{obj?.attributes?.Name_of_the_Student}</td>
                            <td>
                              {obj?.attributes?.Number_of_Paper_Presented}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {
                      <BlocksRenderer
                        content={data?.data?.attributes?.Body || []}
                      />
                    }
                  </div>
                </div>
              </div>
              <div className="col-lg-3 pl-20 md-pl-14">
                <div className="about-intro">
                  <QuickLinks />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Accredation /> */}

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup secondaryColor" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default StudentActivities;
